import { render, staticRenderFns } from "./planes.vue?vue&type=template&id=7b70d332&scoped=true"
import script from "./planes.vue?vue&type=script&lang=js"
export * from "./planes.vue?vue&type=script&lang=js"
import style0 from "./planes.vue?vue&type=style&index=0&id=7b70d332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b70d332",
  null
  
)

export default component.exports